import React, {useCallback, useState} from 'react';

import {LicenseCheckErrorsForm} from '../LicenseCheckErrorsForm';
import {LicenseImportForm} from '../LicenseImportForm';

const LicenseStep = {
    FileUpload: 'file_upload',
    FormSubmission: 'form_submission',
} as const;
export type LicenseStep = (typeof LicenseStep)[keyof typeof LicenseStep];

const LicenseImportSteps = ({handleOnClose}: {handleOnClose: () => void}): JSX.Element => {
    const [step, setStep] = useState<LicenseStep>(LicenseStep.FileUpload);
    const [csvFileContent, setCsvFileContent] = useState('');

    const incrementStep = useCallback(() => {
        setStep(LicenseStep.FormSubmission);
    }, []);

    if (step === LicenseStep.FileUpload) {
        return (
            <LicenseCheckErrorsForm
                onProceed={incrementStep}
                onCsvFileContentChanged={setCsvFileContent}
            />
        );
    }

    return (
        <LicenseImportForm
            csvFileContent={csvFileContent}
            handleOnClose={handleOnClose}
        />
    );
};

export default LicenseImportSteps;
